var React = require('react');

function BurgerOpen (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.587.667H8.413C3.56.667.667 3.56.667 8.413v11.16c0 4.867 2.893 7.76 7.746 7.76h11.16c4.854 0 7.747-2.893 7.747-7.746V8.413C27.333 3.56 24.44.667 19.587.667ZM20.666 21H7.332c-.546 0-1-.453-1-1 0-.547.454-1 1-1h13.334c.546 0 1 .453 1 1 0 .547-.454 1-1 1Zm0-6H7.332c-.546 0-1-.453-1-1 0-.547.454-1 1-1h13.334c.546 0 1 .453 1 1 0 .547-.454 1-1 1Zm0-6H7.332c-.546 0-1-.453-1-1 0-.547.454-1 1-1h13.334c.546 0 1 .453 1 1 0 .547-.454 1-1 1Z","fill":"currentColor"}));
}

BurgerOpen.defaultProps = {"width":"1em","height":"1em","fill":"none","viewBox":"0 0 28 28"};

module.exports = BurgerOpen;

BurgerOpen.default = BurgerOpen;
